import React, { useState, useMemo } from "react";
import { birthdayInfo, formatBirthday } from "../birthdays";
import "./BirthdaysPanel.css";

const AVATAR_COLORS = [
  ["#3a2a1a", "#f5a623"], ["#3a1a2a", "#F48FB1"], ["#2a1a3a", "#a78bfa"],
  ["#1a3a2a", "#3ecf8e"], ["#1a2a3a", "#4d9ef7"], ["#1a3a3a", "#26C6DA"],
];
function avatarColor(id) { return AVATAR_COLORS[(id?.charCodeAt(0) || 0) % AVATAR_COLORS.length]; }

const WINDOWS = [
  { label: "next 7 days", value: 7 },
  { label: "next 30 days", value: 30 },
  { label: "next 90 days", value: 90 },
];

export default function BirthdaysPanel({ workers = [] }) {
  const [days, setDays] = useState(30);
  const today = useMemo(() => new Date(), []);

  const upcoming = useMemo(() => {
    return workers
      .map(w => {
        const info = birthdayInfo(w.birthday, today);
        return info ? { ...w, ...info } : null;
      })
      .filter(w => w && w.daysUntil <= days)
      .sort((a, b) => a.daysUntil - b.daysUntil);
  }, [workers, days, today]);

  const fmt = formatBirthday;

  return (
    <aside className="bday-panel">
      <div className="bday-header">
        <div className="bday-title-row">
          <div>
            <div className="bday-title">🎂 Upcoming Birthdays</div>
            <div className="bday-subtitle">Team celebrating soon</div>
          </div>
          <select className="bday-window" value={days} onChange={e => setDays(parseInt(e.target.value))}>
            {WINDOWS.map(w => <option key={w.value} value={w.value}>{w.label}</option>)}
          </select>
        </div>
        <div className="bday-count">
          {upcoming.length} birthday{upcoming.length !== 1 ? "s" : ""} in the {WINDOWS.find(w => w.value === days)?.label}
        </div>
      </div>

      <div className="bday-list">
        {upcoming.length === 0 && (
          <div className="bday-empty">
            <div style={{ fontSize: 22, marginBottom: 6 }}>🎈</div>
            <p>No birthdays in this window</p>
          </div>
        )}
        {upcoming.map(w => {
          const [bg, fg] = avatarColor(w.id);
          const isToday = w.daysUntil === 0;
          return (
            <div key={w.id} className={`bday-card ${isToday ? "bday-today" : ""}`}>
              <div className="bday-avatar" style={{ background: bg, color: fg }}>
                {(w.firstName || "?")[0]}{(w.lastName || "?")[0]}
              </div>
              <div className="bday-info">
                <div className="bday-name">
                  {w.firstName} {w.lastName}
                  {w.role && <span className={`role-chip role-${w.role.toLowerCase()}`}>{w.role}</span>}
                </div>
                <div className="bday-meta">
                  {fmt(w.month, w.day)} · turns {w.turning}
                </div>
              </div>
              <div className="bday-when">
                {isToday
                  ? <span className="bday-badge-today">Today 🎉</span>
                  : <span className="bday-days">{w.daysUntil === 1 ? "tomorrow" : `in ${w.daysUntil}d`}</span>}
              </div>
            </div>
          );
        })}
      </div>
    </aside>
  );
}
